const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M6 10.03c-.09 0-.17.02-.26.03.28-.82.61-1.46.92-1.93.39-.57.75-.93 1-1.13.12-.1.21-.16.25-.19l.03-.02v-.01C8.57 6.45 9 5.79 9 5.03c0-1.1-.9-2-2-2-.32 0-.62.08-.89.22v-.01c-.24.11-1.54.83-2.77 2.68C2.1 7.76.99 10.7 1 15.03c0 2.76 2.24 5 5 5s5-2.24 5-5c0-2.77-2.24-5-5-5zm12 0c-.09 0-.17.02-.26.03.28-.82.61-1.45.93-1.92.38-.58.74-.94.99-1.14.12-.1.21-.16.25-.19l.03-.02v-.01c.63-.33 1.06-.99 1.06-1.75 0-1.1-.9-2-2-2-.32 0-.62.08-.89.22v-.01c-.23.12-1.54.83-2.77 2.68-1.24 1.84-2.35 4.78-2.34 9.11 0 2.76 2.24 5 5 5s5-2.24 5-5c0-2.77-2.24-5-5-5z"
});

const SvgQuote = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuote, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/quote.aa414e2e.svg";
export { ForwardRef as ReactComponent };